import {
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  QueryList,
  ContentChildren,
  OnDestroy,

} from '@angular/core';
import { SwiperContainer, SwiperSlide } from 'swiper/element/bundle';
import { Swiper, SwiperOptions } from 'swiper/types';
import { register } from 'swiper/element/bundle';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
register(); // This line should add to the project every where you know just one time will excuted like app module or app.config.ts

@Component({
  selector: 'app-smash-swiper',
  templateUrl: './smash-swiper.component.html',
  styleUrls: ['./smash-swiper.component.scss'],
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SmashSwiperComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() swiperContainerId = '';
  @Input() index: number;
  @Input() items: any;
  @Input() config?: SwiperOptions;
  @Output() indexChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() reachedEnd: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('swiper') swiperRef!: ElementRef<SwiperContainer>;
  @ContentChildren('smashSwiperSlide') swiperSlides: QueryList<any>;
  activeIndex: number;
  show = true;
  subscriptions: Subscription[] = [];

  constructor() { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.activeIndex = this.index;
    if (this.swiperRef) {
      this.swiperRef.nativeElement.initialize();
      this.swiperRef.nativeElement.swiper.on('activeIndexChange', (swiper: Swiper) => {
        if (this.activeIndex > swiper.activeIndex) {
          this.indexChanged.emit({ direction: 'left', index: swiper.activeIndex });
        } else {
          this.indexChanged.emit({ direction: 'right', index: swiper.activeIndex });
        }
        this.activeIndex = swiper.activeIndex;
      });
      this.swiperRef.nativeElement.swiper.on('reachEnd', () => {
        this.reachedEnd.emit('reachEnd');
      });
    }
    this.subscriptions.push(
      this.swiperSlides.changes.subscribe(() => {
        this.swiperRef.nativeElement.swiper.update();
      })
    );
  }

  changeSlide(prevOrNext: number): void {
    if (!this.activeIndex && prevOrNext === -1) {
      // do nothing .. you are on first slide
    } else if (this.activeIndex > 0 && prevOrNext === -1) {
      this.swiperRef.nativeElement.swiper.slidePrev();
    } else {
      this.swiperRef.nativeElement.swiper.slideNext();
    }
  }

  ngOnDestroy() {
    this.subscriptions.map(subscription => subscription.unsubscribe())
  }
}